import { Card, CardContent } from './ui/card';
import { Users } from 'lucide-react';

export function ReferralBanner() {
  return (
    <Card className="bg-gradient-to-r from-[#0F172A] to-[#1E3A5F] border-0 overflow-hidden" data-testid="referral-banner">
      <CardContent className="py-6 px-6 flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-teal-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Users className="w-5 h-5 text-teal-400" />
        </div>
        <div>
          <p className="font-semibold text-white text-sm mb-1.5">¿Ya conoces Klarvi? Trae a un amigo.</p>
          <p className="text-[13px] text-slate-300 leading-relaxed">
            Si se hace Pro Anual, te regalamos un mes de Pro. Si se hace Pro Mensual, te descontamos 10% de tu mensualidad por cada mes que se mantenga activo. Trae varios amigos y los descuentos se suman hasta que tu Pro quede gratis.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
